var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8418 4.07617L12.3828 9.50004L17.8418 14.9239C17.9405 14.7177 18.0004 14.4896 18.0004 14.2461V4.75395C18.0004 4.51042 17.9405 4.28243 17.8418 4.07617Z",
    fill: "#328734"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.418 3.17188H1.58207C1.33855 3.17188 1.11056 3.23175 0.904297 3.33043L7.88151 10.2725C8.49843 10.8894 9.50165 10.8894 10.1186 10.2725L17.0958 3.33043C16.8895 3.23175 16.6615 3.17188 16.418 3.17188Z",
    fill: "#328734"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.158555 4.07617C0.0598711 4.28243 0 4.51042 0 4.75395V14.2461C0 14.4897 0.0598711 14.7177 0.158555 14.9239L5.61758 9.50004L0.158555 4.07617Z",
    fill: "#328734"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6368 10.2456L10.8643 11.0181C9.83634 12.046 8.16371 12.046 7.13578 11.0181L6.36332 10.2456L0.904297 15.6695C1.11056 15.7682 1.33855 15.828 1.58207 15.828H16.418C16.6615 15.828 16.8895 15.7682 17.0958 15.6695L11.6368 10.2456Z",
    fill: "#328734"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailGreenIcon);
export default __webpack_public_path__ + "static/media/mail_green_icon.b947b1e5481489403b55e66a0c503c98.svg";
export { ForwardRef as ReactComponent };